/**
 * CRO College Combobox — Searchable dropdown for Shop by College
 *
 * Populates a filterable list of all colleges from cro-location-index.js.
 * Renders inside the mega-nav panel as a combobox with keyboard support.
 *
 * Dependencies: cro-location-index.js must be loaded first.
 */
(function () {
  'use strict';

  var input = document.getElementById('CroCollegeSearchInput');
  var list = document.getElementById('CroCollegeList');
  var viewAll = document.getElementById('CroCollegeViewAll');

  if (!input || !list) return;

  var allColleges = [];
  var focusedIdx = -1;
  var visibleLinks = [];

  /* Wait for location index to be available */
  function init() {
    if (!window.CRO || !window.CRO.locationIndex) {
      setTimeout(init, 100);
      return;
    }

    /* Extract all colleges, sorted alphabetically */
    allColleges = window.CRO.locationIndex
      .filter(function (loc) { return loc.type === 'college'; })
      .sort(function (a, b) { return a.name.localeCompare(b.name); });

    /* Update the "All X Colleges" link count */
    if (viewAll) {
      viewAll.textContent = 'All ' + allColleges.length + ' Colleges \u2192';
    }

    renderList('');
  }

  init();

  /* --- Filtering --- */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    focusedIdx = -1;
    renderList(q);
  });

  /* --- Rendering --- */
  function renderList(query) {
    var q = query.toLowerCase();
    var filtered = allColleges;

    if (q) {
      filtered = allColleges.filter(function (loc) {
        return loc.name.toLowerCase().indexOf(q) > -1 ||
               loc.slug.indexOf(q.replace(/\s+/g, '-')) > -1;
      });

      /* Sort: prefix matches first */
      filtered.sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        var aPrefix = aName.indexOf(q) === 0 ? 1 : 0;
        var bPrefix = bName.indexOf(q) === 0 ? 1 : 0;
        if (bPrefix !== aPrefix) return bPrefix - aPrefix;
        return aName.localeCompare(bName);
      });
    }

    var html = '';

    filtered.forEach(function (loc) {
      var url = '/collections/all/category:collegiate+loc-name:' + loc.slug;
      var name = q ? highlightMatch(loc.name, query) : escapeHtml(loc.name);
      html += '<li class="cro-mega-nav__college-item" role="option">' +
        '<a href="' + escapeHtml(url) + '" class="cro-mega-nav__college-link">' +
        name + '</a></li>';
    });

    if (filtered.length === 0) {
      html = '<li class="cro-mega-nav__college-item" style="padding:12px 20px;color:#9ca3af;font-size:13px;">No colleges found</li>';
    }

    list.innerHTML = html;
    visibleLinks = Array.prototype.slice.call(list.querySelectorAll('.cro-mega-nav__college-link'));
    focusedIdx = -1;
  }

  /* --- Keyboard navigation --- */
  input.addEventListener('keydown', function (e) {
    if (visibleLinks.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusedIdx = Math.min(focusedIdx + 1, visibleLinks.length - 1);
      updateFocus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      focusedIdx = Math.max(focusedIdx - 1, -1);
      updateFocus();
    } else if (e.key === 'Enter' && focusedIdx >= 0) {
      e.preventDefault();
      var link = visibleLinks[focusedIdx];
      if (link && link.href) window.location.href = link.href;
    }
  });

  function updateFocus() {
    visibleLinks.forEach(function (el, i) {
      if (i === focusedIdx) {
        el.classList.add('cro-mega-nav__college-link--focused');
        el.scrollIntoView({ block: 'nearest' });
      } else {
        el.classList.remove('cro-mega-nav__college-link--focused');
      }
    });
  }

  /* Auto-focus the input when the panel opens (hover) */
  var panel = input.closest('.cro-mega-nav__panel');
  var navItem = panel ? panel.closest('.cro-mega-nav__item') : null;
  if (navItem) {
    navItem.addEventListener('mouseenter', function () {
      setTimeout(function () { input.focus(); }, 50);
    });
    navItem.addEventListener('mouseleave', function () {
      input.blur();
      input.value = '';
      renderList('');
      focusedIdx = -1;
    });
  }

  /* --- Helpers --- */
  function highlightMatch(text, query) {
    if (!query) return escapeHtml(text);
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return escapeHtml(text);
    return escapeHtml(text.substring(0, idx)) +
      '<mark>' + escapeHtml(text.substring(idx, idx + query.length)) + '</mark>' +
      escapeHtml(text.substring(idx + query.length));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

})();
